import type { FunctionComponent } from 'react'
import { useContext, useEffect } from 'react'

import { ReviewsCompareTray } from '../../../../shared/components/ReviewsCompareTray/ReviewsCompareTray'
import { CompareTrayContext } from '../../../../shared/contexts/CompareTrayContext'

type Props = {
  taxonomySlug: string
}

export const CompareTrayWrapper: FunctionComponent<Props> = ({ taxonomySlug }) => {
  const {
    setTaxonomySlug,
    compareTrayItems,
    taxonomySlug: currentTaxonomySlug,
    removeHandler,
    removeAllProducts,
    compareProducts,
  } = useContext(CompareTrayContext)
  useEffect(() => {
    if (taxonomySlug && taxonomySlug !== currentTaxonomySlug) {
      setTaxonomySlug(taxonomySlug)
    }
  }, [taxonomySlug, setTaxonomySlug, currentTaxonomySlug])

  if ((compareTrayItems?.length ?? 0) <= 0) {
    return null
  }

  return (
    <ReviewsCompareTray
      taxonomySlug={currentTaxonomySlug}
      products={compareTrayItems}
      removeHandler={removeHandler}
      removeAllHandler={removeAllProducts}
      compareHandler={compareProducts}
      skipToContent={{
        text: 'Return to article',
        selector: 'h1[data-testid="headline"]',
      }}
    />
  )
}
